import "./Editorial.module.css";
import Header from "@/reusable_sections/Header";
import EditorialTeam from "./sections/EditorialTeam";
import Footer from "@/reusable_sections/Footer";
export default function EditorialPage() {
  return <div>
      <Header />
      <EditorialTeam />
      <Footer />
    </div>;
}